export const LICENSES_URL = '/licenses'
export const CLAIMS_URL = '/claims'
export const RECLAIM_URL = '/reclaim'
export const SUPPORT_ACCOUNTS = '/support_accounts'
export const PAE_VALIDATION_URL = '/validate/pae'
export const LICENSE_QUOTA_URL = '/license_quotas'
export const ACTIVATE_URL = '/activate'
export const INSTANCE_URL = '/instances'
export const VALIDATE_PANORAMA_URL = '/validate/panorama'
export const TENANT_DEVICES = '/tenant_devices'
export const SUPPORT_DEVICES = '/support_account_devices'
export const NOT_ELIGIBLE_APPS_DEVICE_ASSOCIATION = '/das_ineligible_apps'
export const APP_DEVICE_ASSOCIATION = '/applications_devices_association'
export const MODIFY_SUBSCRIPTION_URL = '/modifySubscription'
export const PANORAMA_OTP = '/panorama/otp'
export const HASHES_URL = '/hashes'
